module.exports = __webpack_public_path__ + "img/sneaker.a7a6a365.svg";